import { render, staticRenderFns } from "./setAuth.vue?vue&type=template&id=71d10094&scoped=true&"
import script from "./setAuth.vue?vue&type=script&lang=js&"
export * from "./setAuth.vue?vue&type=script&lang=js&"
import style0 from "./setAuth.vue?vue&type=style&index=0&id=71d10094&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d10094",
  null
  
)

export default component.exports